import {AttachedFile} from "./BaseTypes.ts";
import SparkMD5 from 'spark-md5';
// import {VirtualSelect} from "virtual-select-plugin/src/virtual-select.js";
import 'virtual-select-plugin/dist/virtual-select.min.js';
import {HoursAnalysisReportProps, ReportDataRow} from "../HoursAnalaysisReport/types.ts";
import { predefinedRangesPlugin } from "../Utilities/dateRangePlugin.js";
import moment from "moment";
import {OptionsType} from "react-flatpickr";
export function escapeRegex(string: string): string {
    return string.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
}

export function sumArray(array: number[]) {
    if (!(array instanceof Array)) return 0;
    let sum = 0;
    array.forEach(v => sum = sum + v);
    return sum;
}

let _running = false;
export async function getAttachedFilesWithHashes(files: File[]): Promise<AttachedFile[]> {
    if (_running) {
        return;
    }

    if (!files?.length) {
        return;
    }

    const promises = [];
    files.forEach(file => {
        promises.push(new Promise((resolve, reject) => {
                const blobSlice = File.prototype.slice,
                    chunkSize = 2097152,                             // Read in chunks of 2MB
                    chunks = Math.ceil(file.size / chunkSize),
                    spark = new SparkMD5.ArrayBuffer(),
                    fileReader = new FileReader();

                let currentChunk = 0;


                fileReader.onload = function (e) {
                    spark.append(e.target.result);                   // Append array buffer
                    currentChunk++;

                    if (currentChunk < chunks) {
                        loadNext();
                    } else {
                        _running = false;
                        const hash = spark.end();
                        resolve({
                            attachedFileSize: file.size,
                            attachedFileName: file.name,
                            verifiedFilePath: '',
                            attachedFileChecksum: hash
                        })
                        console.info('computed hash', hash);  // Compute hash
                    }
                };

                fileReader.onerror = function () {
                    _running = false;
                    console.warn('oops, something went wrong.');
                    reject();
                };

                function loadNext() {
                    const start = currentChunk * chunkSize,
                        end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;

                    fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
                }

                _running = true;

                loadNext();
            })
        )
    })

    return await Promise.all(promises);

}


export async function consoleLogKioskFetch(url: string | URL | Request, options: RequestInit) {
    return kioskFetch(url, options)
        .catch(error => {
            console.log(error);
        });
}
export async function windowAlertKioskFetch(url: string | URL | Request, options: RequestInit) {
    return kioskFetch(url, options)
        .catch(error => {
            window.alert('Request Failed: ' + error);
        })
}
export async function kioskFetch(url: string | URL | Request, options: RequestInit): Promise<HoursAnalysisReportProps> {
    return fetch(url, options)
        .then(res => {
            if (res.redirected) return Promise.reject("Could not complete request because you're not logged on");
            if (!res.ok) return Promise.reject(res.status + ": " + res.statusText);

            // 1. Get the content-type header
            const contentType = res.headers.get("content-type");

            // 2. Check if it includes 'application/json'
            if (contentType && contentType.includes("application/json")) {
                return res.json();
            } else {
                return res.text();
            }
        })
}


export const defaultVirtualSelectSingleOptions = {
    dropboxWidth: '25em',
    optionsCount: 12,
    multiple: false,
    showSelectedOptionsFirst: false,
    disableAllOptionsSelectedText: true,
    hideClearButton: true,
    // silentInitialValueSet: true
};
export const defaultVirtualSelectMultiOptions = {
    dropboxWidth: '25em',
    optionsCount: 12,
    multiple: true,
    showSelectedOptionsFirst: true,
    disableAllOptionsSelectedText: true,
    // silentInitialValueSet: true
};
export const defaultVirtualSelectAddableMultiOptions = {
    ...defaultVirtualSelectMultiOptions,
    allowNewOption: true,
}

export const initialiseVSSelect = function (elIdentifier, beforeOpenHandler = null, options = null, filterOptionsCallback = null, name = '') {
    let el = null;
    if (typeof elIdentifier === 'object') {
        el = elIdentifier;
    } else {
        el = document.querySelector(elIdentifier);
    }
    if (!el) return;
    if (!options) options = defaultVirtualSelectAddableMultiOptions;
    if (options?.multiple)
        el.multiple = true;

    // @ts-expect-error alt import
    const instance = VirtualSelect.init({ele: elIdentifier, ...options});

    // console.log('got instance');


    // elIdentifier.initialising = true;

    instance.$searchClear && instance.$searchClear.addEventListener('click', () => {
        instance.moveSelectedOptionsFirst();
    })

    // el = document.querySelector(elIdentifier);
    // el = document.querySelector(elIdentifier);
    el = instance.$ele;

    if (beforeOpenHandler) el.addEventListener('beforeOpen', (e) => {
        beforeOpenHandler(e, filterOptionsCallback);
    });
    el.addEventListener('change', function (e) {
        // console.log('init vsselect change handler');
        let selected = this.getSelectedOptions();
        const mostRecentValue = this.value[this.value.length - 1];

        this.querySelectorAll('input[type="hidden"]').forEach(el => el.remove());
        if (!name) name = this.name;

        if (this.value !== undefined) {
            let values = this.value;
            //should be array
            if (!Array.isArray(this.value))
                values = [this.value];

            this.insertAdjacentHTML('afterbegin', `${values.map(v => `<input type='hidden' name='${name}' value='${v}' />`).join(' ')}`);
        }

        if (options.multiple) {
            if (!Array.isArray(selected))
                selected = [selected];

            if (selected.find(item => item.value === mostRecentValue)?.isNew) {
                instance.moveSelectedOptionsFirst();
            }
        }
    });

    return instance;
}
export const virtualSelectGroupStaff = (list, teamsIncludeLeaders = false) => {
    const staffByTeam = {};
    list.forEach(function (staff) {
        if (staff.contractor) staff.team = staff.team + ' (External Contractor)';
        if (!staff.team) staff.team = 'No Team';
        if (!staff.active) staff.team = 'Inactive'
        if (!staffByTeam[staff.team]) staffByTeam[staff.team] = [];
        staffByTeam[staff.team].push(staff);
        if (teamsIncludeLeaders && staff.leaderOf) {
            if (!staffByTeam[staff.leaderOf]) staffByTeam[staff.leaderOf] = [];
            staffByTeam[staff.leaderOf].push(staff);
        }
    });
    return Object.keys(staffByTeam).map(team => {
        return {
            label: team,
            options: staffByTeam[team].map(staff => {
                return {
                    'label': `${staff.firstName} ${staff.lastName}`,
                    'value': staff.id
                };
            })
        }
    })
        .sort((a, b) => a.label.localeCompare(b.label))
        .sort((a, b) => {
            if (a.label === 'Contextual Recipients') return -1;
            if (b.label === 'Contextual Recipients') return 1;
            if (a.label === 'Inactive' || a.label === 'No Team') return 1;
            if (b.label === 'Inactive' || b.label === 'No Team') return -1;
            return 0;
        });
}

export function initPickr(pickr) {
    return;
    /* Add a blur event handler on input  used by flatpickr (created if `altInput` is `true`)
* so that changing then leaving it (ie hit tab) will update the saved date value.
* See https://github.com/flatpickr/flatpickr/issues/1551 */
    const {altInput, altFormat, dateFormat} = pickr.config;
    const input = altInput ? pickr.altInput : pickr.element;
    const format = altInput ? altFormat : dateFormat;

    function updateOnBlur(e) {
        // console.log(e);
        // console.log(pickr);
        const currentlySetDateString = pickr.formatDate(pickr.selectedDates[0], 'd/m/Y') + ' to ' + pickr.formatDate(pickr.selectedDates[1], 'd/m/Y');

        if (currentlySetDateString != e.target.value)
            pickr.setDate(e.target.value, true, format);
    }

    input.addEventListener("blur", updateOnBlur);

    console.log('updated pickr v2');

    window.dispatchEvent(new CustomEvent('datepikrinit'));

    return {
        destroy: () => {
            if (pickr) {
                input.removeEventListener("blur", updateOnBlur);
                pickr.destroy();
            }
        },
    };
}

/**
 * Triggers a React synthetic change event by bypassing React's value tracking.
 * This is necessary when non-React libraries update form element values programmatically.
 */
export function triggerReactChangeEvent(element: HTMLElement, value: any, name?: string) {
    const prototype = Object.getPrototypeOf(element);
    const descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');
    if (descriptor && descriptor.set) {
        console.log('desc call');
        descriptor.set.call(element, value);
        console.log('set test3');
        if (name)
            Object.getOwnPropertyDescriptor(prototype, 'name').set.call(element, name);
    } else {
        console.log('val set');
        // Fallback for elements that might not have a 'value' descriptor on their immediate prototype
        (element as any).value = value;
    }
    console.log('disp event');
    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('change', { bubbles: true }));
}

export const flatpickrOptionsRange: OptionsType = {
    mode: "range",
    dateFormat: "d/m/Y",
    allowInput: true,
    showMonths: 2,
    plugins: [
// @ts-expect-error should just be js
        new predefinedRangesPlugin(
            [
                {
                    label: 'This Month',
                    start: moment().startOf('month').toDate(),
                    end: moment().endOf('month').toDate(),
                    isDefaultSelected: false
                },
                {
                    label: 'Last Month',
                    start: moment().subtract(1, 'month').startOf('month').toDate(),
                    end: moment().subtract(1, 'month').endOf('month').toDate(),
                    isDefaultSelected: false
                },
                {
                    label: 'This And Last Month',
                    start: moment().subtract(2, 'month').startOf('month').toDate(),
                    end: moment().endOf('month').toDate(),
                    isDefaultSelected: false
                },
                {
                    label: 'This Week',
                    start: moment().weekday(0).toDate(),
                    end: moment().weekday(6).toDate(),
                    isDefaultSelected: false
                },
                {
                    label: 'Last Week',
                    start: moment().weekday(0).subtract(1, 'week').toDate(),
                    end: moment().weekday(6).subtract(1, 'week').toDate(),
                    isDefaultSelected: false
                },
                {
                    label: 'Last Two Weeks',
                    start: moment().weekday(0).subtract(2, 'week').toDate(),
                    end: moment().weekday(6).subtract(1, 'week').toDate(),
                    isDefaultSelected: false
                },
                {
                    label: 'Last Three Weeks',
                    start: moment().weekday(0).subtract(3, 'week').toDate(),
                    end: moment().weekday(6).subtract(1, 'week').toDate(),
                    isDefaultSelected: false
                },
                {
                    label: 'Last Four Weeks',
                    start: moment().weekday(0).subtract(4, 'week').toDate(),
                    end: moment().weekday(6).subtract(1, 'week').toDate(),
                    isDefaultSelected: false
                },
            ],

            {
                extraRangesContainerClasses: [],
                extraRangeOptionClasses: [],
                extraRangeOptionSelectedClasses: [],
            }
        )
    ]
}

